import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import HomeNavbar from './components/HomeNavbar.vue'
import HomeFooter from './components/HomeFooter.vue'
import { onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  if (!localStorage.getItem('program')) localStorage.setItem('program', JSON.stringify([]))
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HomeNavbar),
    _createVNode(_component_router_view),
    _createVNode(HomeFooter)
  ]))
}
}

})